import React from 'react';
import PropTypes from "prop-types";
import './style.scss';
import {FormattedMessage} from 'react-intl';
import BikeDriverIcon from './BikeDriverIcon';
import CarDriverIcon from './CarDriverIcon';

const serviceTypeToDriverPhoto = {
  "go-ride": <BikeDriverIcon/>,
  "go-car": <CarDriverIcon/>,
};

const isNotEmpty = word => /\S/.test(word)
const secondLineSeparator = (name, model) => (name && isNotEmpty(name) && model && isNotEmpty(model)) ? " • " : null;

export default class DriverDetails extends React.Component {
  static propTypes = {
    serviceType: PropTypes.string.isRequired,
    name: PropTypes.string,
    vehicleNumber: PropTypes.string,
    vehicleModel: PropTypes.string,
    photographUrl: PropTypes.string,
  }

  driverPhoto() {
    if (this.props.photographUrl) {
      return <img alt="Driver" src={this.props.photographUrl}/>
    }
    var defaultIcon = serviceTypeToDriverPhoto[this.props.serviceType];
    return defaultIcon ? defaultIcon : <CarDriverIcon/>;
  }

  render() {
    let {name, vehicleModel, vehicleNumber} = this.props;
    
    let firstLine, secondLineFirstField, secondLineSecondField;
    
    if (vehicleNumber && isNotEmpty(vehicleNumber)) {
      firstLine = vehicleNumber;
      secondLineFirstField = name;
      secondLineSecondField = vehicleModel;
    } else if (vehicleModel && isNotEmpty(vehicleModel)){
      firstLine = name;
      secondLineFirstField = vehicleModel;
    } else if (name) {
      firstLine = name;
      secondLineFirstField = "GOJEK DRIVER";
    } else {
      firstLine = <FormattedMessage id={"Driver.noDriver.title"}/>
      secondLineFirstField = <FormattedMessage id={"Driver.noDriver.message"}/>
    }

    const separator = secondLineSeparator(secondLineFirstField, secondLineSecondField);
    
    return (
      <div className="DriverDetails BorderBottom">
        <div className="leftColumn">
          <div className="photo">
            {this.driverPhoto()}
          </div>
        </div>
        <div className="rightColumn">
          <div className="firstLine">{firstLine}</div>
          <div className="secondLine">
            <span className="secondLineFirstField">{secondLineFirstField}</span>{separator}<span className="secondLineSecondField">{secondLineSecondField}</span>
          </div>
        </div>
      </div>
    );
  }
}

